module.exports = __webpack_public_path__ + "img/SWF.a5999526.png";